<splash-screen
  [attr.logo]="logoUrl$ | async"
></splash-screen>
